module.exports = __webpack_public_path__ + "3bb39cfb.svg";